import { lazy } from "react";

const routes = [
  {
    path: "/settings/subscription",
    element: lazy(() => import("../../pages/Settings/Subscription")),
  },
];

export default routes;
